import { put, takeLatest } from "redux-saga/effects";
import {
  fetchLocalCommunityTrainerRolesRequest,
  fetchLocalCommunityTrainerRolesSuccess,
  fetchLocalCommunityTrainerRolesFailure,
} from "./localCommunityTrainerRoleSlice";
import { fastApiURL } from "../../utils/config";

function* fetchLocalCommunityTrainerRolesSaga() {
  try {
    const response = yield fetch(`${fastApiURL}/api/local-community-trainer-roles`);

    if (!response.ok) {
      throw new Error(`Failed to fetch LCT roles: ${response.status}`);
    }

    const data = yield response.json();

    const roles = data.map((role) => ({
      id: role.id,
      name: role.name,
      description: role.description
    }));

    yield put(fetchLocalCommunityTrainerRolesSuccess(roles));
  } catch (error) {
    console.error("Error in fetchLocalCommunityTrainerRolesSaga:", error);
    yield put(fetchLocalCommunityTrainerRolesFailure(error.message));
  }
}

export function* watchLocalCommunityTrainerRolesSaga() {
  yield takeLatest(
    fetchLocalCommunityTrainerRolesRequest.type,
    fetchLocalCommunityTrainerRolesSaga
  );
}